module.exports = __webpack_public_path__ + "static/media/joinusFood2.b2e304d2.jpg";